import { useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";

export interface UseEnduserChatMessagesOptions {
  roomId: string;
  limit?: number;
  enabled?: boolean;
}

export function useEnduserChatMessages(options: UseEnduserChatMessagesOptions) {
  const { roomId, limit = 50, enabled = true } = options;

  const query = useTellescopeInfiniteQuery({
    model: "chats",
    method: "getSome",
    request: {
      filter: { roomId },
      limit,
    },
    select: (data) => data.pages.flat(),
    enabled: enabled && !!roomId,
  });

  const allMessages = query.data ?? [];

  // Sort by timestamp (oldest first for chat display)
  const sortedMessages = [...allMessages].sort((a, b) => {
    const aTime = a.timestamp ? new Date(a.timestamp).getTime() : new Date(a.updatedAt).getTime();
    const bTime = b.timestamp ? new Date(b.timestamp).getTime() : new Date(b.updatedAt).getTime();
    return aTime - bTime;
  });

  return {
    ...query,
    messages: sortedMessages,
  };
}
